import { matchPath } from 'react-router';

import { ERoutes } from '@/types/routes';

const ROUTE_PATTERNS: string[] = [
  ERoutes.DASHBOARD,
  ERoutes.DASHBOARD_SETTINGS,
  `${ERoutes.ENTITY}/:entityName`,
  ERoutes.RISK_SIMULATOR,
  ERoutes.RISK_SIMULATOR_PORTFOLIO,
  ERoutes.STABLECOINS,
  `${ERoutes.STABLECOINS}/:agioId`,
  ERoutes.ALERTING,
  `${ERoutes.ALERTING}/:alertId`,
  `${ERoutes.DOCUMENTATION}/*`,
  ERoutes.SETTINGS,
  ERoutes.LOGIN,
  ERoutes.FORGOT_PASSWORD,
  `${ERoutes.ONBOARDING}/:token`,
  ERoutes.RESET_PASSWORD,
];

// the routes that were replaced and are still redirected for the sake of old links
const LEGACY_ROUTES: string[] = [
  ERoutes.MONITORING_ENTITY,
  ERoutes.MONITORING_SETTINGS,
  ERoutes.RATINGS,
];

const toPathname = (target: string) => target.split('?')[0].split('#')[0];

export const isKnownRoute = (target: string): boolean =>
  ROUTE_PATTERNS.some(pattern => !!matchPath(pattern, toPathname(target)));

// a legacy route is an old top-level path, so it can only ever start a pathname. Testing for it
// with `includes` also claims any path that merely contains one, and a documentation page such as
// "/documentation/products/ratings/statistical-ratings-srs" was being redirected as if it were the
// old "/ratings" view
export const isRouteOrDescendant = (target: string, route: string): boolean => {
  const pathname = toPathname(target);

  return pathname === route || pathname.startsWith(`${route}/`);
};

export const isLegacyRoute = (target: string): boolean =>
  LEGACY_ROUTES.some(route => isRouteOrDescendant(target, route));
